<template>
	<div class="memberBenefits-container">
		<div class="cjt-head">
			<!-- 顶部导航栏 -->
			<top-nav-head></top-nav-head>
		</div>
		<div class="memberBenefits-main">
			<div class="memberBenefits-content">
				<div class="memberBenefits-banner"></div>
				<div class="vip-bg">
					<div class="memberBenefits-join">
						<h3 class="memberBenefits-title">立即成为会员</h3>
						<div class="memberBenefits-pay">
							<div class="pay-box">
								<h4 class="pay-title">
									<span>VIP会员</span>
									满足中小企业使用
								</h4>
								<div class="pay-money">
									<div
										v-for="(item, index) in memeberVipPriceList"
										:key="index"
										class="money-box"
										:class="{ active: activityPackageInfo.vipId === item.id }"
										@click="handleSelectMoney(item)"
									>
										<!-- 活动标签 -->
										<div v-if="item.tag" class="tag-label">{{ item.tag }}</div>
										<h5 class="money-title">{{ formatDuration(item.longDuration) }}</h5>
										<div class="pay-price">
											<p class="now-price">
												<span>¥</span>
												{{ item.eventPrice }}
											</p>
											<p v-if="item.packagePrice !== item.eventPrice" class="old-price">
												<span>¥</span>
												{{ item.packagePrice }}
											</p>
										</div>
									</div>
								</div>
								<div class="pay-payment">
									<div class="pay-text">
										<div>
											<span>
												活动到期时间：
											</span>
											<span>{{ activityPackageInfo.vipExpirationTime || '-' }}</span>
										</div>
										<div>
											<span>
												会员到期时间：
											</span>
											<span>{{ activityPackageInfo.vipEndingTime || '-' }}</span>
										</div>
										<div>
											<span>实付金额：</span>
											<p class="actual-price">
												<span>¥</span>
												{{ activityPackageInfo.vipActualPayment || 0 }}
											</p>
										</div>
									</div>
									<div class="pay-button-group">
										<el-button
											:disabled="!activityPackageInfo.vipActualPayment"
											class="pay-button"
											@click="handleCreateOrderInfo('vip')"
										>
											点击购买
										</el-button>
									</div>
									<!-- <div class="pay-ewm">
										<img src="@/assets/memberBenefits/ewm.png" alt="支付二维码" />
										<p>
											请使用
											<img src="@/assets/memberBenefits/zfb.png" alt="支付宝支付" />
											<img src="@/assets/memberBenefits/wx.png" alt="微信支付" />
											扫码支付
										</p>
									</div> -->
								</div>

								<div class="pay-term-link">
									<h6>购买须知</h6>
									<div class="term-item">
										<el-checkbox v-model="isAgreedTerms" class="term-checkbox"></el-checkbox>
										<p class="text">
											1. 开通前请阅读
											<router-link target="_blank" to="/term" class="term-link">《会员权益说明》</router-link>
											<router-link target="_blank" to="/law" class="term-link">《会员升级说明》</router-link>
										</p>
									</div>
									<div class="term-item">
										<p class="text">2. 完成支付后可在个人中心-我的发票中申请发票</p>
									</div>

									<!-- <p class="text">3. 若您已有会员，再次开通前请阅读《会员升级说明》</p> -->
								</div>
							</div>
							<div class="pay-box svip">
								<h4 class="pay-title">
									<span>SVIP会员</span>
									满足大型企业使用
								</h4>
								<div class="pay-money">
									<div
										v-for="(item, index) in memberSVipPriceList"
										:key="index"
										class="money-box"
										:class="{ active: activityPackageInfo.svipId === item.id }"
										@click="handleSelectMoney(item)"
									>
										<!-- 活动标签 -->
										<div v-if="item.tag" class="tag-label">{{ item.tag }}</div>
										<h5 class="money-title">{{ formatDuration(item.longDuration, 'SVIP') }}</h5>
										<div class="pay-price">
											<p class="now-price">
												<span>¥</span>
												{{ item.eventPrice }}
											</p>
											<p v-if="item.packagePrice !== item.eventPrice" class="old-price">
												<span>¥</span>
												{{ item.packagePrice }}
											</p>
										</div>
									</div>
								</div>
								<div class="pay-payment">
									<div class="pay-text">
										<div>
											<span>
												活动到期时间：
											</span>
											<span>{{ activityPackageInfo.svipExpirationTime || '-' }}</span>
										</div>
										<div>
											<span>
												会员到期时间：
											</span>
											<span>{{ activityPackageInfo.svipEndingTime || '-' }}</span>
										</div>
										<div>
											<span>实付金额：</span>
											<p class="actual-price">
												<span>¥</span>
												{{ activityPackageInfo.svipActualPayment || 0 }}
											</p>
										</div>
									</div>
									<div class="pay-button-group">
										<el-button
											:disabled="!activityPackageInfo.svipActualPayment"
											class="pay-button"
											@click="handleCreateOrderInfo('svip')"
										>
											点击购买
										</el-button>
									</div>
									<!-- <div class="pay-ewm">
										<img src="@/assets/memberBenefits/ewm.png" alt="支付二维码" />
										<p>
											请使用
											<img src="@/assets/memberBenefits/zfb.png" alt="支付宝支付" />
											<img src="@/assets/memberBenefits/wx.png" alt="微信支付" />
											扫码支付
										</p>
									</div> -->
								</div>
								<div class="pay-term-link">
									<h6>购买须知</h6>
									<div class="term-item">
										<el-checkbox v-model="isAgreedTerms" class="term-checkbox"></el-checkbox>
										<p class="text">
											1. 开通前请阅读
											<router-link target="_blank" to="/term" class="term-link">《会员权益说明》</router-link>
											<router-link target="_blank" to="/law" class="term-link">《会员升级说明》</router-link>
										</p>
									</div>
									<div class="term-item">
										<p class="text">2. 完成支付后可在个人中心-我的发票中申请发票</p>
									</div>
									<!-- <p class="text">3. 若您已有会员，再次开通前请阅读《会员升级说明》</p> -->
								</div>
							</div>
						</div>
					</div>
					<div class="memberBenefits-now">
						<h3 class="memberBenefits-title">会员权益一览</h3>
						<div class="memberBenefits-power">
							<div class="power-box">
								<h4>
									<span>VIP会员</span>
									查询、诊断 、招聘更高效
								</h4>
								<div class="power-text">
									<p>
										<span>高级搜索，</span>
										高效，精准获取目标人员、企业、项目
									</p>
									<p>
										<span>查待注册信息，</span>
										发现闲余资质
									</p>
									<p>
										<span>查行政处罚、黑名单，</span>
										识别潜在风险
									</p>
									<p>
										<span>看人员、企业画像，</span>
										洞察信用与风险
									</p>
									<p>
										<span>
											导出人员企业项目等
										</span>
										多种类型数据
									</p>
									<p>
										<span>
											资质托管提示，
										</span>
										避免资质失效
									</p>
									<p>
										<span>
											资质诊断，
										</span>
										助力资质新办、升级、更新延续
									</p>
									<p>
										<span>招聘人员分析，</span>
										决策辅助招聘
									</p>
									<p>……</p>
									<p class="more">
										等
										<span>54</span>
										项权益
									</p>
								</div>
								<el-button class="join-button" @click="toBuy">低至2.5元/天，去购买</el-button>
							</div>
							<div class="power-box svip">
								<h4>
									<span>SVIP会员</span>
									查询、诊断 、招聘更高效
								</h4>
								<div class="power-text">
									<p>
										<span>下载诊断报告，</span>
										评估资质水平
									</p>
									<p>
										<span>人员、企业、项目动态实时推送</span>
									</p>
									<p>
										<span>畅享人员、企业、项目报告导出</span>
									</p>
									<p>
										<span>资质动态变化定制化托管预警</span>
									</p>
									<p>
										<span>
											简历下载，
										</span>
										畅享无限便利
									</p>
									<p>
										<span>
											企业招聘广告，
										</span>
										尊享位置置顶权
									</p>
									<p>
										<span>享有招聘特权，</span>
										实施特别人才筛选
									</p>
									<p>
										<span>精准匹配，</span>
										高效推介优秀人才
									</p>
									<p>……</p>
									<p class="more">
										等
										<span>54</span>
										项权益
									</p>
								</div>
								<el-button class="join-button" @click="toBuy">低至3.7元/天，去购买</el-button>
							</div>
						</div>
					</div>
				</div>

				<div ref="allPowerContent" class="allPower-content">
					<h3 class="memberBenefits-title">全部权益</h3>
					<div class="allPower-box">
						<!-- 添加占位元素，防止固定标题时内容跳动 -->
						<div class="title-placeholder" :style="{ height: isFixedTitle ? titleHeight + 'px' : '0px' }"></div>
						<div ref="benefitTitle" class="member-benefit-title" :class="{ 'fixed-title': isFixedTitle }">
							<span class="intro">服务介绍说明</span>
							<span class="vip">普通会员（立即注册）</span>
							<span class="svip">高级会员（VIP）</span>
							<span class="ssvip">超级会员（SVIP）</span>
						</div>

						<div class="member-benefit-content">
							<div v-for="(item, index) in memberBenefitList" :key="index" class="benefit-group">
								<div class="benefit-group-title">
									<span>{{ item.name }}</span>
								</div>

								<div class="benefit-group-content">
									<div v-for="(item1, index1) in item.memberBenefitTemplateVos" :key="index1" class="benefit-group-list">
										<span class="intro">
											<b>{{ item1.memberBenefitName }}</b>
											<p>{{ item1.remark }}</p>
										</span>
										<span class="vip">{{ item1.pthyMemberBenefitContent }}</span>
										<span class="svip">{{ item1.vipMemberBenefitContent }}</span>
										<span class="ssvip">{{ item1.svipMemberBenefitContent }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 支付方式--start -->
				<div class="way-content">
					<div class="way-box">
						<h3 class="memberBenefits-title">支持多种支付方式</h3>
						<p>
							支付后可在线开发票，让您报销无忧！如有任何疑问，
							<span @click="openQQService">联系客服</span>
							获得帮助
						</p>
						<div class="payment-method">
							<div class="method-box">
								<img src="@/assets/memberBenefits/zfb.png" alt="" />
								支付宝
							</div>
							<div class="method-box">
								<img src="@/assets/memberBenefits/wx.png" alt="" />
								微信
							</div>
							<div class="method-box">
								<img src="@/assets/memberBenefits/kjzf.png" alt="" />
								对公转账
							</div>
						</div>
					</div>
				</div>
				<!-- 支付方式--end -->

				<!-- 常见问题--start -->
				<div class="question-content">
					<h3 class="memberBenefits-title">会员购买常见问题</h3>
					<div class="question-box">
						<div class="questions">
							<h5>Q：购买会员后多久到账？</h5>
							<div class="question-text">
								<span class="da-span">A：</span>
								<P>
									正常情况下完成支付后会员立即到账，若超过5分钟仍未生效，请
									<span @click="openQQService">联系客服</span>
									核实情况。
								</P>
							</div>
						</div>
						<div class="questions">
							<h5>Q：购买会员后是否可退款？</h5>
							<div class="question-text">
								<span class="da-span">A：</span>
								<P>
									因数据服务特殊性，会员服务一经生效不支持退款。
								</P>
							</div>
						</div>
						<div class="questions">
							<h5>Q：提供什么类型的发票？发票内容是什么？</h5>
							<div class="question-text">
								<span class="da-span">A：</span>
								<P>
									购买会员后，支持申请增值税普通发票或增值税专用发票；
									发票抬头支持个人或公司抬头，发票内容为技术服务费或信息服务费，税点为6%，申请开票后会在1个工作日内发至所填邮箱。
								</P>
							</div>
						</div>
						<div class="questions">
							<h5>Q：如何查看会员到期时间？</h5>
							<div class="question-text">
								<span class="da-span">A：</span>
								<P>
									点击网页右上角头像，进入
									<router-link to="/user/profile">个人中心</router-link>
									<!-- <span>个人中心</span> -->
									查看。
								</P>
							</div>
						</div>
					</div>
				</div>
				<!-- 常见问题--end -->
			</div>
		</div>
		<!-- 底部服务流程向导 -->
		<footer-guide></footer-guide>

		<!-- 页脚 -->
		<page-footer></page-footer>
	</div>
</template>

<script>
	import TopNavHead from '@/components/TopNavHead'
	import PageFooter from '@/components/PageFooter'
	import FooterGuide from '@/components/FooterGuide/index'
	import { mapGetters } from 'vuex'
	import { Debounce } from '@/utils'
	import { queryMyMemberBenefitRecord, queryMemberPriceByUserId, createOrderInfo } from '@/api/memberBenefit/index'
	import QQService from '@/mixins/QQService'

	export default {
		name: 'MemberBenefits',
		components: {
			TopNavHead,
			FooterGuide,
			PageFooter
		},
		mixins: [QQService],
		props: {},
		data() {
			return {
				// 全部的会员价格信息
				memeberAllPriceList: [],
				// vip会员价格信息
				memeberVipPriceList: [],
				// svip会员价格信息
				memberSVipPriceList: [],
				// 是否同意条款状态
				isAgreedTerms: false,
				// 所选会员活动套餐信息
				activityPackageInfo: {
					// 活动套餐主键id
					id: '',
					// 活动id
					eventId: '',
					// 套餐id
					packageId: '',
					// vip活动套餐主键id
					vipId: '',
					// vip活动id
					vipEventId: '',
					// 套餐id
					vipPackageId: '',
					// VIP活动截止时间
					vipExpirationTime: '',
					// VIP会员预计到期时间
					vipEndingTime: '',
					// VIP实付金额
					vipActualPayment: '',
					// svip活动套餐主键id
					svipId: '',
					// svip活动id
					svipEventId: '',
					// svip套餐id
					svipPackageId: '',
					// SVIP活动截止时间
					svipExpirationTime: '',
					// SVIP会员预计到期时间
					svipEndingTime: '',
					// SVIP实付金额
					svipActualPayment: ''
				},

				// 会员权益一览表
				memberBenefitList: [],
				// 标题栏固定状态
				isFixedTitle: false,
				// 标题栏高度
				titleHeight: 0
			}
		},
		computed: {
			...mapGetters(['userId'])
		},
		watch: {},
		created() {
			this.handleGetMemberPriceByUserId()
			this.handleGetMemberBenefitRecord()
			// 创建防抖后的滚动函数
			this.debounceScroll = Debounce(this.handleScroll, 10)
		},
		mounted() {
			// 获取初始标题高度
			this.$nextTick(() => {
				if (this.$refs.benefitTitle) {
					this.titleHeight = this.$refs.benefitTitle.offsetHeight
				}
			})

			// 添加滚动事件监听
			window.addEventListener('scroll', this.debounceScroll)
		},
		beforeDestroy() {
			// 组件销毁前移除事件监听
			window.removeEventListener('scroll', this.debounceScroll)
		},
		methods: {
			// 查询会员权益汇总
			handleGetMemberBenefitRecord() {
				queryMyMemberBenefitRecord().then(response => {
					const { data } = response

					if (data && data.length) {
						// 取出第0项，平台基础会员
						const { memberBenefitTemplateVos } = data[0]

						this.memberBenefitList = memberBenefitTemplateVos
					} else {
						this.memberBenefitList = []
					}
				})
			},

			// 查询会员价格信息
			handleGetMemberPriceByUserId() {
				const params = {
					userId: this.userId
				}
				queryMemberPriceByUserId(params).then(response => {
					const { data } = response
					if (data && data.length) {
						this.memeberAllPriceList = data
						// 根据会员等级进行过滤，提取VIP和SVIP的价格信息，并根据longDuration字段进行降序排序
						this.memeberVipPriceList = data
							.filter(item => item.memberGrade === 'VIP')
							.sort((a, b) => b.longDuration - a.longDuration)
						this.memberSVipPriceList = data
							.filter(item => item.memberGrade === 'SVIP')
							.sort((a, b) => b.longDuration - a.longDuration)

						// 默认选中第一个套餐
						this.handleSelectMoney(this.memeberVipPriceList[0])
						this.handleSelectMoney(this.memberSVipPriceList[0])
					} else {
						this.memeberAllPriceList = []
						this.memeberVipPriceList = []
						this.memberSVipPriceList = []
					}
				})
			},

			// 选择套餐
			handleSelectMoney(item) {
				this.activityPackageInfo.eventId = item.itemEventPromotionId
				this.activityPackageInfo.packageId = item.itemPackageId
				// 根据会员等级区分设置到期时间和实付金额
				if (item.memberGrade === 'VIP') {
					this.activityPackageInfo.vipId = item.id
					this.activityPackageInfo.vipEventId = item.itemEventPromotionId
					this.activityPackageInfo.vipPackageId = item.itemPackageId
					this.activityPackageInfo.vipExpirationTime = item.eventEndTime
					// 这里的时间要根据longDuration与当前时间进行计算 longDuration 返回的是天数
					this.activityPackageInfo.vipEndingTime = this.calculateEndTime(item.longDuration)
					this.activityPackageInfo.vipActualPayment = item.eventPrice
				} else if (item.memberGrade === 'SVIP') {
					this.activityPackageInfo.svipId = item.id
					this.activityPackageInfo.svipEventId = item.itemEventPromotionId
					this.activityPackageInfo.svipPackageId = item.itemPackageId
					this.activityPackageInfo.svipExpirationTime = item.eventEndTime
					this.activityPackageInfo.svipEndingTime = this.calculateEndTime(item.longDuration)
					this.activityPackageInfo.svipActualPayment = item.eventPrice
				}
			},

			// 计算会员到期时间
			calculateEndTime(days) {
				if (!days) return '-'

				const now = new Date()
				const endDate = new Date(now.getTime() + parseInt(days) * 24 * 60 * 60 * 1000)

				// 格式化日期为 YYYY-MM-DD
				const year = endDate.getFullYear()
				const month = String(endDate.getMonth() + 1).padStart(2, '0')
				const day = String(endDate.getDate()).padStart(2, '0')

				return `${year}-${month}-${day}`
			},

			// 格式化会员时长显示
			formatDuration(days, type = 'VIP') {
				if (!days) return ''

				// 将字符串转为数字
				const daysNum = parseInt(days)

				if (daysNum >= 365) {
					// 计算年数
					const years = Math.floor(daysNum / 365)
					return `${years}年${type}`
				} else {
					// 计算月数 (按30天一个月计算)
					const months = Math.ceil(daysNum / 30)
					return `${months}个月${type}`
				}
			},

			// 生成用户会员活动消费订单信息
			handleCreateOrderInfo(vipType) {
				if (!this.isAgreedTerms) {
					// 未点击阅读购买须知
					this.$modal.msgWarning('请先阅读并勾选购买须知')
					// 获取所有购买须知选择框元素
					const checkboxElements = document.querySelectorAll('.term-checkbox')

					// 为每个选择框添加抖动动画
					checkboxElements.forEach(checkbox => {
						// 先移除可能存在的抖动动画类
						checkbox.classList.remove('shake')

						// 触发重绘
						void checkbox.offsetWidth

						// 添加抖动动画类
						checkbox.classList.add('shake')

						// 动画结束后移除类名
						setTimeout(() => {
							checkbox.classList.remove('shake')
						}, 600) // 动画持续时间
					})
					return
				}

				// 收集活动id和套餐id
				const data = {
					eventId: '',
					packageId: ''
				}

				console.log('activityPackageInfo:', this.activityPackageInfo)

				if (vipType === 'vip') {
					data.eventId = this.activityPackageInfo.vipEventId
					data.packageId = this.activityPackageInfo.vipPackageId
				} else if (vipType === 'svip') {
					data.eventId = this.activityPackageInfo.svipEventId
					data.packageId = this.activityPackageInfo.svipPackageId
				}

				this.$modal
					.confirm('请确认是否为您选择的活动套餐创建订单？')
					.then(() => {
						return createOrderInfo(data)
					})
					.then(() => {
						this.$modal.msgSuccess('订单创建成功')
						this.$router.push({
							path: '/user/market/order'
						})
					})
					.catch(() => {})
			},

			// 处理滚动事件
			handleScroll() {
				if (!this.$refs.allPowerContent || !this.$refs.benefitTitle) return

				const contentRect = this.$refs.allPowerContent.getBoundingClientRect()

				// 使用阈值避免边界抖动
				const threshold = 10

				// 当标题栏顶部到达视口顶部时固定，且整个内容区域还在视口内
				if (contentRect.top <= -threshold && contentRect.bottom > this.titleHeight + threshold) {
					this.isFixedTitle = true
				} else {
					this.isFixedTitle = false
				}
			},

			// 去购买
			toBuy() {
				// 获取购买按钮元素
				const payBtnElement = document.getElementsByClassName('pay-button-group')
				// 将元素滚动到容器可视区域中
				payBtnElement[0].scrollIntoView({
					// 滚动位置，值有：start, center, end, nearest
					block: 'center',
					// 缓动动画，值有：auto,instant,smooth
					behavior: 'smooth'
				})
			},

			// 打开企点客服
			openQQService() {
				this.handleEvokeQQ()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/memberBenefit.scss';

	.memberBenefits-main {
		background-color: #f7f7f7;
		.memberBenefits-content {
			.memberBenefits-banner {
				height: 600px;
				background: url('~@/assets/memberBenefits/banner.jpg') 50% 50% no-repeat;
			}
			.vip-bg {
				background: #fff;
				padding-top: 53px;
				padding-bottom: 51px;
				.memberBenefits-join {
					width: $main-page-width;
					margin: 0 auto;
					margin-bottom: 61px;
					.memberBenefits-pay {
						display: flex;
						gap: 40px;
						.pay-box {
							width: 680px;
							height: 590px;
							background-image: linear-gradient(0deg, #fff4e9 0%, #ffffff 55%);
							border-radius: 10px;
							border: solid 1px #ffa34e;
							overflow: hidden;
							.pay-title {
								height: 104px;
								background: linear-gradient(90deg, rgba(255, 216, 142, 0.4) 0%, rgba(250, 162, 80, 0.4) 100%),
									url('~@/assets/memberBenefits/vip.png') no-repeat bottom 0px right 67px;
								font-size: 22px;
								color: #934e25;
								line-height: 104px;
								padding-left: 161px;
								span {
									font-size: 34px;
									color: #934e25;
									margin-right: 10px;
								}
							}
							.pay-money {
								margin-top: 45px;
								padding: 0px 20px;
								display: flex;
								justify-content: space-between;
								.money-box {
									width: 201px;
									height: 175px;
									background-color: #ffffff;
									border-radius: 10px;
									border: solid 1px #ffc99d;
									// overflow: hidden;
									cursor: pointer;
									transition: all 0.3s ease;
									transform: scale(1);
									display: flex;
									flex-direction: column;
									position: relative;

									// 添加标签样式
									.tag-label {
										position: absolute;
										top: -10px;
										left: -10px;
										background-image: linear-gradient(135deg, #ff7a18 0%, #ff9538 100%);
										color: #fff;
										font-size: 12px;
										padding: 2px 10px;
										z-index: 2;
										font-weight: bold;
										box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
										clip-path: polygon(0 0, 100% 0, 100% 70%, 85% 100%, 0 100%);
										transform: rotate(-5deg);
									}

									.money-title {
										width: 100%;
										height: 59px;
										background: linear-gradient(90deg, rgba(255, 216, 142, 0.4) 0%, rgba(250, 162, 80, 0.4) 100%);
										border-radius: 10px 10px 0 0;
										font-size: 26px;
										color: #934e25;
										text-align: center;
										line-height: 59px;
									}

									.pay-price {
										flex: 1;
										display: flex;
										flex-direction: column;
										justify-content: center;
										.now-price {
											font-size: 36px;
											font-weight: bold;
											color: #e64000;
											text-align: center;
											margin-bottom: 12px;
											span {
												font-size: 30px;
											}
										}

										.old-price {
											font-size: 24px;
											color: #a4a4a4;
											text-align: center;
											text-decoration: line-through;
											span {
												font-size: 20px;
											}
										}
									}
								}
								.money-box.active {
									border: solid 1px #fda155;
									position: relative;
									// overflow: hidden;
									animation: pulse 0.5s ease;
									.money-title {
										background-image: linear-gradient(90deg, #ffc664 0%, #ff9338 100%);
										color: #fff;
									}
									&::before {
										content: '';
										position: absolute;
										right: 0;
										bottom: 0;
										width: 40px;
										height: 40px;
										background: linear-gradient(90deg, #ffc664 0%, #ff9338 100%);
										clip-path: polygon(100% 0, 100% 100%, 0 100%);
										border-radius: 0 0 10px 0;
									}

									&::after {
										content: '';
										position: absolute;
										right: 5px;
										bottom: 5px;
										width: 16px;
										height: 12px;
										background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath d='M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z' fill='%23ffffff'/%3E%3C/svg%3E");
										background-repeat: no-repeat;
										background-size: 100%;
										background-position: 50% 50%;
										z-index: 1;
									}
								}
							}
							.pay-payment {
								display: flex;
								justify-content: space-between;
								margin-top: 18px;
								padding: 0px 20px;
								.pay-text {
									width: 375px;
									div {
										display: flex;
										width: 100%;
										justify-content: space-between;
										font-size: 18px;
										color: #333333;
										margin-bottom: 10px;
									}
									h6 {
										font-size: 18px;
										color: #934e25;
										margin-bottom: 16px;
									}
									// .text {
									// 	font-size: 16px;
									// 	color: #b26a3f;
									// 	line-height: 28px;
									// }

									.actual-price {
										font-size: 36px;
										font-weight: bold;
										color: #e64000;
										height: 29px;
										line-height: 29px;
										text-align: center;
										margin-bottom: 12px;
										span {
											font-size: 30px;
										}
									}
								}
								.pay-ewm {
									width: 185px;
									text-align: center;
									p {
										font-size: 18px;
										color: #333333;
										display: flex;
										align-items: center;
										justify-content: center;
										margin-top: 15px;
										img {
											width: 23px;
											height: 23px;
											object-fit: contain;
											margin: 0px 2px;
										}
									}
								}
							}

							.pay-term-link {
								padding: 0px 20px;

								h6 {
									font-size: 18px;
									color: #934e25;
									margin-bottom: 16px;
								}

								.term-item {
									display: flex;
									align-items: center;
									margin-bottom: 10px;

									.term-checkbox {
										margin-right: 10px;

										::v-deep .el-checkbox__inner {
											width: 18px;
											height: 18px;
											border-color: #ff9538;

											&:after {
												border-color: #fff;
											}
										}

										::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
											background-color: #ff9538;
											border-color: #ff9538;

											&::after {
												height: 9px;
												left: 6px;
											}
										}
									}

									.text {
										font-size: 16px;
										color: #b26a3f;
										line-height: 28px;
									}

									&:last-child {
										.text {
											padding-left: 28px; // 与复选框对齐
										}
									}
								}

								.term-link {
									color: #236fca;
									text-decoration: none;
									margin: 0 3px;

									&:hover {
										text-decoration: underline;
									}
								}
							}

							.pay-button-group {
								.pay-button {
									width: 200px;
									background-image: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
									border-radius: 6px;
									font-size: 18px;
									color: #ffffff;
									text-align: center;
									line-height: 50px;
									padding: 0px;
									border: none;
									transition: all 0.3s ease;
									box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

									&:hover {
										transform: translateY(-2px);
										box-shadow: 0 5px 15px rgba(255, 149, 56, 0.4);
										background-image: linear-gradient(90deg, #ffd17a 0%, #ffa04d 100%);
									}
								}
							}

							&.svip {
								.pay-money {
									.money-box {
										.tag-label {
											background-image: linear-gradient(135deg, #fe8e8a 0%, #f84621 100%);
											transform: rotate(-5deg);
										}
									}
								}

								.pay-button {
									background-image: linear-gradient(90deg, #fe8e8a 0%, #f94825 100%);
									&:hover {
										background-image: linear-gradient(90deg, #fe8e8a 0%, #f94825 100%);
									}
								}
							}
						}
						.svip {
							background-image: linear-gradient(0deg, #fff6f6 0%, #ffffff 48%);
							border: solid 1px #ff9282;
							.pay-title {
								background: linear-gradient(90deg, rgba(255, 204, 184, 0.4) 0%, rgba(255, 158, 132, 0.4) 100%),
									url('~@/assets/memberBenefits/svip.png') no-repeat bottom 0px right 67px;
								padding-left: 135px;
								color: #f2450a;
								span {
									color: #f2450a;
								}
							}
							.pay-money {
								.money-box {
									border: solid 1px #ffbcb2;
									.money-title {
										background-image: linear-gradient(90deg, #ffe5dd 0%, #ffd3c9 100%);
										color: #f2450a;
									}
								}
								.money-box.active {
									border: solid 1px #ff9282;
									.money-title {
										background-image: linear-gradient(90deg, #fe8e8a 3%, #f84621 100%);
									}
									&::before {
										background: linear-gradient(135deg, #fe8e8a 3%, #f84621 100%);
									}
								}
							}
						}
					}
				}
				.memberBenefits-now {
					width: $main-page-width;
					margin: 0 auto;
					.memberBenefits-power {
						display: flex;
						justify-content: space-between;
						.power-box {
							width: 680px;
							height: 624px;
							background-image: linear-gradient(0deg, #ffffff 72%, #ffeed0 100%);
							border-radius: 10px;
							border: solid 1px #ffa34e;
							padding: 32px 115px;
							h4 {
								font-size: 22px;
								color: #934e25;
								text-align: center;
								span {
									font-size: 34px;
									margin-right: 21px;
								}
							}
							.power-text {
								margin-top: 51px;
								p {
									position: relative;
									padding-left: 38px;
									font-size: 18px;
									color: #333333;
									line-height: 40px;
									&::before {
										content: '';
										position: absolute;
										left: 0;
										top: 50%;
										transform: translateY(-50%);
										width: 19px;
										height: 19px;
										border-radius: 50%;
										background: #ff993d;
										background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23ffffff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E");
										background-size: 12px;
										background-position: center;
										background-repeat: no-repeat;
									}
									span {
										color: #934e25;
									}
								}
								.more {
									padding-left: 0px;
									span {
										font-size: 30px;
										color: #934e25;
									}
									&::before {
										display: none;
									}
								}
							}
							.join-button {
								width: 450px;
								height: 50px;
								background-image: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
								border-radius: 6px;
								font-size: 18px;
								color: #ffffff;
								text-align: center;
								line-height: 50px;
								padding: 0px;
								border: none;
								margin-top: 25px;
								transition: all 0.3s ease;
								box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
								cursor: pointer;

								&:hover {
									transform: translateY(-2px);
									box-shadow: 0 5px 15px rgba(255, 149, 56, 0.4);
									background-image: linear-gradient(90deg, #ffd17a 0%, #ffa04d 100%);
								}
							}
						}
						.svip {
							background-image: linear-gradient(0deg, #ffffff 72%, #ffe5dc 100%);
							border: solid 1px #ff9282;
							h4 {
								color: #f2450a;
							}
							.power-text {
								p {
									&::before {
										background-color: #ff5c25;
									}
									span {
										color: #f2450a;
									}
								}
								.more {
									span {
										color: #f2450a;
									}
								}
							}
							.join-button {
								background-image: linear-gradient(90deg, #fe8e8a 0%, #f94825 100%);
								&:hover {
									background-image: linear-gradient(90deg, #fe8e8a 0%, #f94825 100%);
								}
							}
						}
					}
				}
			}
			.allPower-content {
				padding-top: 50px;
				padding-bottom: 41px;
				.allPower-box {
					width: $main-page-width;
					margin: 0 auto;
				}
			}
			.way-content {
				background: #fff;
				padding: 43px 0px 56px 0px;
				.way-box {
					width: $main-page-width;
					margin: 0 auto;
					p {
						font-size: 20px;
						color: #333333;
						text-align: center;
						span {
							color: #236fca;
							cursor: pointer;
						}
					}
					.payment-method {
						width: 836px;
						height: 154px;
						background: linear-gradient(90deg, rgba(156, 220, 246, 0.35) 0%, transparent 100%),
							url('~@/assets/memberBenefits/pay.png') right bottom no-repeat;
						border-radius: 10px;
						position: relative;
						margin: 0 auto;
						margin-top: 59px;
						display: flex;
						align-items: center;
						justify-content: center;
						z-index: 1;

						&::before {
							content: '';
							position: absolute;
							top: 0;
							left: -17px;
							width: 100%;
							height: 100%;
							background-image: linear-gradient(90deg, #9cdcf6 2%, transparent 100%);
							-webkit-transform: skew(-15deg);
							transform: skew(-15deg);
							z-index: -1;
							border-radius: 10px;
							width: 30%;
						}
						.method-box {
							display: flex;
							flex-direction: column;
							align-items: center;
							margin-right: 87px;
							font-size: 18px;
							color: #333333;
							transition: all 0.3s ease;
							cursor: pointer;

							&:hover {
								transform: translateY(-5px);
								color: #236fca;
								img {
									transform: scale(1.1);
								}
							}
							img {
								width: 71px;
								height: 71px;
								margin-bottom: 13px;
								transition: all 0.3s ease;
							}
						}
					}
				}
			}
			.question-content {
				padding: 41px 0px 53px 0px;
				.question-box {
					display: flex;
					flex-wrap: wrap;
					width: $main-page-width;
					margin: 0 auto;
					justify-content: space-between;
					.questions {
						width: 681px;
						height: 171px;
						background-color: #ffffff;
						border-radius: 6px;
						flex-shrink: 0;
						margin-bottom: 32px;
						overflow: hidden;
						transition: all 0.3s ease;
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

						&:hover {
							transform: translateY(-3px);
							box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
							background-color: #f9f9f9;
						}
						&:nth-child(3) {
							height: 203px;
						}
						&:nth-child(4) {
							height: 203px;
						}
						h5 {
							height: 60px;
							background-image: linear-gradient(90deg, #ffb536 1%, #ff9538 100%);
							line-height: 60px;
							padding-left: 43px;
							font-size: 18px;
							color: #ffffff;
							font-weight: bold;
						}
						.question-text {
							display: flex;
							height: calc(100% - 60px);
							padding: 25px 59px 0px 42px;
							align-items: flex-start; /* 确保子元素从顶部开始排列 */
							.da-span {
								font-size: 18px;
								color: #ff9638;
								font-weight: bold;
								margin-right: 12px;
								line-height: auto;
							}
							p {
								font-size: 18px;
								color: #333333;
								span,
								a {
									color: #236fca;
									cursor: pointer;
								}
							}
						}
					}
				}
			}
		}
		.memberBenefits-title {
			font-size: 26px;
			color: #333;
			text-align: center;
			margin-bottom: 40px;
		}
	}
	@keyframes pulse {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.03);
		}
		100% {
			transform: scale(1);
		}
	}
</style>
